/*
 * Copyright (c) 2019-2023 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by Rahul Bagaria <rahul.bagaria@wakencode.com>, Nov 2023
 *
 */

import {  
  IImageList,
  IImageListParam  
} from "../../model/images/index";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosResponse } from "axios";
import { IthunkAPI } from "../../model";
import { getHeaders } from "../../utility/helper";

export const fetchImageList = createAsyncThunk<
  IImageList,
  IImageListParam,
  IthunkAPI
>("images/fetchImageList", async (params, thunkAPI) => {
  const { dispatch, rejectWithValue } = thunkAPI;
  const { id, type } = params;
  try {
    const response: AxiosResponse<any> = await axios.get(
      `${process.env.REACT_APP_API_URL}/${type}/${id}/images`,
      await getHeaders(dispatch)
    );
    return {
      data: response?.data ?? [],
    };
  } catch (err: any) {
    return rejectWithValue(err?.response?.data?.errorDescription);
  }
});

